import { render, staticRenderFns } from "./oversold_handle.vue?vue&type=template&id=73a36166&scoped=true"
import script from "./oversold_handle.vue?vue&type=script&lang=js"
export * from "./oversold_handle.vue?vue&type=script&lang=js"
import style0 from "./oversold_handle.vue?vue&type=style&index=0&id=73a36166&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a36166",
  null
  
)

export default component.exports